export enum ShoppingFlowType {
  Ancillary = 'ANCILLARY',
  Insurance = 'INSURANCE',
  PowerUp = 'POWERUP'
}
